module.exports = __webpack_public_path__ + "static/media/app-02.d23d937e.png";